(function () {
  var MARKERS_INHALT = ['ki-inhalt', '[ai]', '[ki]'];
  var MARKERS_STIMME = ['ki-stimme'];
  var SELECTOR = 'img, video';

  function getConfig() {
    var el = document.getElementById('sc-ai-badge-config');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function detectType(node) {
    var explicit = (node.getAttribute('data-sc-ai') || '').toLowerCase();
    if (explicit.indexOf('ki-stimme') !== -1) return 'ki-stimme';
    if (explicit.indexOf('ki-inhalt') !== -1) return 'ki-inhalt';

    var haystack = [
      node.getAttribute('alt') || '',
      node.getAttribute('aria-label') || '',
      node.getAttribute('data-alt') || '',
    ]
      .join(' ')
      .toLowerCase();

    for (var i = 0; i < MARKERS_STIMME.length; i++) {
      if (haystack.indexOf(MARKERS_STIMME[i]) !== -1) return 'ki-stimme';
    }
    for (var j = 0; j < MARKERS_INHALT.length; j++) {
      if (haystack.indexOf(MARKERS_INHALT[j]) !== -1) return 'ki-inhalt';
    }
    return '';
  }

  function closestMediaHost(node) {
    return (
      node.closest(
        '.media-wrapper, .product__media-item-container, .product-card__image, video-element, .media'
      ) || node.parentElement
    );
  }

  function createBadge(type, config) {
    var wrap = document.createElement('span');
    wrap.className =
      'sc-ai-badge sc-ai-badge--' +
      (config.position || 'bottom-left') +
      (config.showTooltip ? ' sc-ai-badge--tooltip' : '');
    wrap.style.setProperty('--sc-ai-badge-offset', (config.offset || 10) + 'px');
    wrap.setAttribute('data-sc-ai', type);

    var tooltipText =
      type === 'ki-stimme' ? config.tooltipVoice : config.tooltipImage;

    if (config.showTooltip) {
      var icon = document.createElement('span');
      icon.className = 'sc-ai-badge__icon';
      icon.setAttribute('aria-label', tooltipText);
      icon.innerHTML = '<span aria-hidden="true">' + (config.label || 'AI') + '</span>';

      var tooltip = document.createElement('span');
      tooltip.className = 'sc-ai-badge__tooltip';
      tooltip.setAttribute('aria-hidden', 'true');
      tooltip.textContent = tooltipText;

      wrap.appendChild(icon);
      wrap.appendChild(tooltip);
    } else {
      var iconOnly = document.createElement('span');
      iconOnly.className = 'sc-ai-badge__icon';
      iconOnly.setAttribute('aria-label', tooltipText);
      iconOnly.innerHTML = '<span aria-hidden="true">' + (config.label || 'AI') + '</span>';
      wrap.appendChild(iconOnly);
    }

    return wrap;
  }

  function scan(config) {
    if (!config) return;
    var thumbnailBadges = document.querySelectorAll(
      '.product__media-gallery-thumbails .sc-ai-badge, .rio-media-gallery .rio-hide-scrollbar .sc-ai-badge'
    );
    for (var t = 0; t < thumbnailBadges.length; t++) {
      thumbnailBadges[t].remove();
    }

    var nodes = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (
        node.closest(
          '.sc-ai-badge, .product__thumbs-container, .product__media-gallery-thumbails, .rio-media-gallery .rio-hide-scrollbar'
        )
      ) {
        continue;
      }

      var type = detectType(node);
      if (!type) continue;

      var host = closestMediaHost(node);
      if (!host) continue;

      var labeledRoot = node.closest('.product__media-item-container, .image-with-text-overlay') || host;
      if (labeledRoot.querySelector('.sc-ai-badge')) continue;

      var hostStyle = window.getComputedStyle(host);
      if (hostStyle.position === 'static') {
        host.style.position = 'relative';
      }

      host.appendChild(createBadge(type, config));
    }
  }

  function closeAll(except) {
    var openBadges = document.querySelectorAll('.sc-ai-badge--open');
    for (var i = 0; i < openBadges.length; i++) {
      if (openBadges[i] === except) continue;
      openBadges[i].classList.remove('sc-ai-badge--open');
    }
  }

  function bind() {
    document.addEventListener('click', function (event) {
      var icon = event.target.closest('.sc-ai-badge--tooltip .sc-ai-badge__icon');
      if (icon) {
        var badge = icon.closest('.sc-ai-badge');
        var isOpen = badge.classList.contains('sc-ai-badge--open');
        closeAll(badge);
        badge.classList.toggle('sc-ai-badge--open', !isOpen);
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      closeAll();
    });
  }

  function init() {
    var config = getConfig();
    if (!config) return;
    scan(config);
  }

  bind();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  var scanTimer;
  var observer = new MutationObserver(function (mutations) {
    var shouldScan = false;
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var addedNode = added[j];
        if (addedNode.nodeType !== 1) continue;
        if (addedNode.classList && addedNode.classList.contains('sc-ai-badge')) continue;
        if (addedNode.matches && addedNode.matches(SELECTOR)) {
          shouldScan = true;
          break;
        }
        if (addedNode.querySelector && addedNode.querySelector(SELECTOR)) {
          shouldScan = true;
          break;
        }
      }
      if (shouldScan) break;
    }
    if (!shouldScan) return;
    clearTimeout(scanTimer);
    scanTimer = setTimeout(init, 150);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
